import type { Profile } from 'models';

export const isContentObjectAuthorProfile = ({
  contentObject,
  viewer,
}: {
  contentObject: { author: { id: string } };
  viewer: Profile;
}) => viewer.id === contentObject.author.id;
